import r from "../../../node_modules/classnames/index.js";
import "./emphasis2.js";
import { jsx as a } from "../../../_virtual/jsx-runtime.js";
function t({
  children: s,
  className: m
}) {
  return /* @__PURE__ */ a("span", {
    className: r("emphasis", m),
    children: s
  });
}
export {
  t as Emphasis
};
//# sourceMappingURL=Emphasis.js.map
